import { createReducer, on } from '@ngrx/store';
//
// Actions
//
import * as appNavBarActions from '../actions/app-navbar.action';
//
// Reducer Interface
//
export interface IAppNavBarState {
  avatar: string;
  menu: string;
  back: string;
  notification: string;
  messages: string
  title: string;
}
//
// Initial State
//
export const IAPP_NAVBAR_INITIAL_STATE: IAppNavBarState = {
  avatar: null,
   menu: null,
  back: null,
  notification: null,
  messages : null,
  title: null
};
export const reducer = createReducer(
  IAPP_NAVBAR_INITIAL_STATE,
  on(appNavBarActions.AppNavBarSetNavigation, (state, {payload}) => _setNavigation(state, payload)),
);

//
// _setHidden()
//
function _setNavigation(state: IAppNavBarState, payload): IAppNavBarState {
   return {...state, ...payload};  
}
//
// General Operations
//
//export const getAppNavBar = (state: IAppNavBarState) => state;
